define([], function() {
    'use strict';
    return function noop() {

    };
});
